import { loadStripe } from "@stripe/stripe-js";

import { formatPrice } from "utils";
import { config } from "api";

export const getPrice = ({price, discount = 0, countryCode}: {price: number, countryCode: string, discount?: number}) => (
    `${formatPrice(Math.round(price * (100 - discount) / 100))} ${countryCode === 'CA' ? '+ HST' : ''}`
)

export const getStripe = async (country: string) => {
    const pubKey = config.stripe[country as 'CA' | 'US'].pubKey
    return await loadStripe(pubKey);
}
